import RecordHelper from "@/bussiness/RecordHelper";
import { avatarBgs } from "@/pages/Voice/SpearkerAvatar/const";

export const avatarMap = new Map();

export const setNewSpeakerAvatar = (speakerName: string, role?: string) => {
  if (!avatarMap.has(speakerName)) {
    const avatarIndex = avatarMap.size % avatarBgs.length;
    const newRole = role || RecordHelper.generateRandomNewRole();
    console.log('setNewSpeakerAvatar', newRole, speakerName)
    avatarMap.set(speakerName, {
      avatar: `${defaultAvatarPrefix}${avatarIndex}`,
      role: newRole
    });
  }
  return avatarMap.get(speakerName);
};

export const defaultAvatarPrefix = "default-";

export const getSpeakerAvatarInfo = (avatar?: string) => {
  if (avatar?.includes(defaultAvatarPrefix)) {
    return {
      avatarIndex: parseInt(avatar.split(defaultAvatarPrefix)[1]),
    };
  }
  return {
    avatarUrl: avatar,
  };
};

export const resetNewSpeakerAvatarMap = () => {
  console.log("resetNewSpeakerAvatarMap");
  avatarMap.clear();
};
